var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1152_12235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#BF3532"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1152_12235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 14L5.21602 12.1C4.41602 11.3778 3.73002 10.7333 3.15802 10.1667C2.58557 9.6 2.11335 9.06667 1.74135 8.56667C1.3689 8.06667 1.09668 7.58333 0.924682 7.11667C0.752238 6.65 0.666016 6.16111 0.666016 5.65C0.666016 4.60556 1.01602 3.736 1.71602 3.04133C2.41602 2.34711 3.28824 2 4.33268 2C4.91046 2 5.46046 2.12222 5.98268 2.36667C6.5049 2.61111 6.9549 2.95556 7.33268 3.4C7.71046 2.95556 8.16046 2.61111 8.68268 2.36667C9.2049 2.12222 9.7549 2 10.3327 2C11.266 2 12.116 2.32778 12.8827 2.98333C13.6494 3.63889 14.0327 4.52778 14.0327 5.65C14.0327 5.80556 14.0216 5.96933 13.9993 6.14133C13.9771 6.31378 13.9438 6.48889 13.8993 6.66667H12.4827C12.5382 6.46667 12.5827 6.27778 12.616 6.1C12.6493 5.92222 12.666 5.75556 12.666 5.6C12.666 4.76667 12.3882 4.18044 11.8327 3.84133C11.2771 3.50267 10.7771 3.33333 10.3327 3.33333C9.76602 3.33333 9.27713 3.48622 8.86602 3.792C8.45491 4.09733 8.07157 4.5 7.71602 5H6.94935C6.6049 4.5 6.21335 4.09733 5.77468 3.792C5.33557 3.48622 4.8549 3.33333 4.33268 3.33333C3.69935 3.33333 3.15202 3.55267 2.69068 3.99133C2.22979 4.43044 1.99935 4.98333 1.99935 5.65C1.99935 6.01667 2.07713 6.38889 2.23268 6.76667C2.38824 7.14444 2.66602 7.58067 3.06602 8.07533C3.46602 8.56956 4.01046 9.14711 4.69935 9.808C5.38824 10.4693 6.26602 11.2667 7.33268 12.2C7.62157 11.9444 7.96046 11.65 8.34935 11.3167C8.73824 10.9833 9.04935 10.7056 9.28268 10.4833L9.43268 10.6333L9.75735 10.9587L10.0827 11.2833L10.2327 11.4333C9.98824 11.6556 9.67713 11.9304 9.29935 12.258C8.92157 12.586 8.58824 12.8778 8.29935 13.1333L7.33268 14ZM9.99935 9.33333V8H15.3327V9.33333H9.99935Z",
    fill: "#BF3532"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedWork);
export default __webpack_public_path__ + "static/media/needWork.47b719f0afcf50e0ca87b70df245ef0f.svg";
export { ForwardRef as ReactComponent };